module.exports = __webpack_public_path__ + "static/media/feishu3-0002.813b992d.png";